import careerService from "../services/career.service";

import { RETRIEVE_CAREER } from "./types";

export const retrieveCareer =
  (params) =>
    async (dispatch) => {
      try {
        const { data } = await careerService.getCareer(params);
        dispatch({
          type: RETRIEVE_CAREER,
          payload: data
        });
      } catch (err) {
        console.log(err);
      }
    };
